import * as z from 'zod';

export const recommendedActionSchema = z.enum(['PROCEED', 'CONFIRM', 'CONFIRM_ADD_SUBPREMISES', 'FIX']);

export type RecommendedAction = z.infer<typeof recommendedActionSchema>;

export const confirmationLevelSchema = z.enum(['CONFIRMED', 'UNCONFIRMED_BUT_PLAUSIBLE', 'UNCONFIRMED_AND_SUSPICIOUS']);

export type ConfirmationLevel = z.infer<typeof confirmationLevelSchema>;

export const validationDecisionSchema = z.enum(['pending', 'keep_current', 'use_recommended']);

export type ValidationDecision = z.infer<typeof validationDecisionSchema>;

export const addressValidationRequestSchema = z.object({
  address1: z.string(),
  address2: z.string().nullable().optional(),
  city: z.string().nullable().optional(),
  postal_code: z.string().nullable().optional(),
  administrative_area: z.string().nullable().optional(),
  country_code: z.string().nullable().optional(),
});

export type AddressValidationRequest = z.infer<typeof addressValidationRequestSchema>;

export const standardizedAddressSchema = z.object({
  first_address_line: z.string().nullable(),
  second_address_line: z.string().nullable(),
  city: z.string().nullable(),
  state: z.string().nullable(),
  zip_code: z.string().nullable(),
  zip_code_extension: z.string().nullable(),
  city_state_zip: z.string().nullable(),
});

export type StandardizedAddress = z.infer<typeof standardizedAddressSchema>;

export const geocodeSchema = z.object({
  latitude: z.number().nullable(),
  longitude: z.number().nullable(),
});

export type Geocode = z.infer<typeof geocodeSchema>;

export const validationVerdictSchema = z.object({
  validation_granularity: z.string().nullable(),
  possible_next_action: z.string().nullable(),
  has_spell_corrected_components: z.boolean(),
  has_replaced_components: z.boolean(),
  has_inferred_components: z.boolean(),
});

export type ValidationVerdict = z.infer<typeof validationVerdictSchema>;

export const addressComponentSchema = z.object({
  text: z.string(),
  type: z.string(),
  confirmation_level: confirmationLevelSchema.nullable(),
  inferred: z.boolean(),
  spell_corrected: z.boolean(),
  replaced: z.boolean(),
  unexpected: z.boolean(),
});

export type AddressComponent = z.infer<typeof addressComponentSchema>;

export const addressValidationResponseSchema = z.object({
  address_validated: z.boolean(),
  recommended_action: recommendedActionSchema.nullable(),
  formatted_address: z.string().nullable(),
  standardized_address: standardizedAddressSchema.nullable(),
  geocode: geocodeSchema.nullable(),
  verdict: validationVerdictSchema.nullable(),
  address_components: z.array(addressComponentSchema).default([]),
});

export type AddressValidationResponse = z.infer<typeof addressValidationResponseSchema>;

export const uspsValidationStatusSchema = z.enum(['verified', 'unverified']);

export type UspsValidationStatus = z.infer<typeof uspsValidationStatusSchema>;
